<a [href]="generalSettingsData.portalGeneralSettingsData.headerLogoLink.link.url" class="logo-link" *ngIf="generalSettingsData">
  <img src="{{generalSettingsData.portalGeneralSettingsData.headerLogoLink.image.content.umbracoFile.src}}" width="150" height="38" alt="Logo">
</a>
<div class="logo-link" aria-hidden="true" *ngIf="!generalSettingsData">
  <app-skeleton [height]="38" [width]="150" />
</div>

